/**
 * Created by Abner Sui on 10/09/2020.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Subject } from 'rxjs';

export class WorkflowTriggerSettingsConfig {
    feedbackSubject$: Subject<any>;
}

export enum WorkflowTriggerSettingsEventTypes {
    CANCLE = 'CANCLE',
    SAVE = 'SAVE',
}

export const WorkflowTriggerSettingsLiterals = {
    ProjectName: 'Project Name',
    Project_Name_Tooltip: 'Please use #CreatedDate#, #Entity#, ##LabelName## to formulate the project name.'
};
